function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var DiscoverLogo = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: [/*#__PURE__*/_jsxs("g", {
    clipPath: "url(#clip0_3686_60163)",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M24.0188 14.179C24.0188 14.179 17.1474 19.0277 4.5625 21.1978H24.0188V14.179Z",
      fill: "#F47216"
    }), /*#__PURE__*/_jsx("path", {
      d: "M1.92157 12.8903C1.697 13.0932 1.40518 13.1817 0.943304 13.1817H0.751446V10.758H0.943304C1.40518 10.758 1.68553 10.8407 1.92157 11.0545C2.16879 11.2746 2.31746 11.6158 2.31746 11.9668C2.31746 12.3187 2.16879 12.6702 1.92157 12.8903ZM1.08645 10.1372H0.0371094V13.802H1.08093C1.63598 13.802 2.03668 13.6712 2.38854 13.3789C2.80667 13.033 3.05389 12.5115 3.05389 11.9722C3.05389 10.8906 2.24582 10.1372 1.08645 10.1372",
      fill: "#231F20"
    }), /*#__PURE__*/_jsx("path", {
      d: "M3.38281 13.8021H4.09771V10.1371H3.38281V13.8021Z",
      fill: "#231F20"
    }), /*#__PURE__*/_jsx("path", {
      d: "M5.84598 11.5435C5.41696 11.3848 5.29108 11.2801 5.29108 11.082C5.29108 10.8512 5.51551 10.6758 5.82361 10.6758C6.0377 10.6758 6.21384 10.7639 6.40004 10.9726L6.77413 10.4828C6.46673 10.2139 6.09901 10.0766 5.69717 10.0766C5.04867 10.0766 4.55409 10.5269 4.55409 11.1266C4.55409 11.6316 4.78432 11.8901 5.45575 12.1317C5.73568 12.2305 5.87813 12.2962 5.94991 12.3404C6.09278 12.4337 6.16428 12.5658 6.16428 12.7197C6.16428 13.0166 5.92825 13.2367 5.60924 13.2367C5.26828 13.2367 4.99359 13.066 4.82906 12.7477L4.36719 13.1925C4.69653 13.676 5.09214 13.8903 5.63614 13.8903C6.37894 13.8903 6.90014 13.3962 6.90014 12.6869C6.90014 12.1045 6.65915 11.841 5.84598 11.5435Z",
      fill: "#231F20"
    }), /*#__PURE__*/_jsx("path", {
      d: "M7.125 11.9721C7.125 13.0494 7.97088 13.8846 9.05944 13.8846C9.36712 13.8846 9.63077 13.8242 9.95573 13.6711V12.8296C9.66999 13.1157 9.41682 13.2311 9.09272 13.2311C8.37272 13.2311 7.86171 12.709 7.86171 11.9668C7.86171 11.2632 8.38886 10.7081 9.05944 10.7081C9.4004 10.7081 9.65852 10.8298 9.95573 11.1205V10.2794C9.64196 10.1203 9.38397 10.0543 9.07629 10.0543C7.99325 10.0543 7.125 10.9065 7.125 11.9721Z",
      fill: "#231F20"
    }), /*#__PURE__*/_jsx("path", {
      d: "M15.6235 12.5988L14.6463 10.1371H13.8652L15.4205 13.8961H15.8052L17.3885 10.1371H16.6136L15.6235 12.5988Z",
      fill: "#231F20"
    }), /*#__PURE__*/_jsx("path", {
      d: "M17.7129 13.802H19.7402V13.1815H18.4272V12.1922H19.6919V11.5715H18.4272V10.758H19.7402V10.137H17.7129V13.802Z",
      fill: "#231F20"
    }), /*#__PURE__*/_jsx("path", {
      d: "M21.1358 11.8244H20.9269V10.7144H21.1471C21.5924 10.7144 21.8344 10.9009 21.8344 11.2576C21.8344 11.626 21.5924 11.8244 21.1358 11.8244ZM22.57 11.2191C22.57 10.5329 22.0974 10.137 21.273 10.137H20.2129V13.802H20.9269V12.3297H21.0203L22.0097 13.802H22.8889L21.735 12.2581C22.2735 12.1486 22.57 11.7802 22.57 11.2191",
      fill: "#231F20"
    }), /*#__PURE__*/_jsx("path", {
      d: "M10.1895 11.9821C10.1895 13.059 11.0622 13.9319 12.139 13.9319C13.2159 13.9319 14.0888 13.059 14.0888 11.9821C14.0888 10.9053 13.2159 10.0327 12.139 10.0327C11.0622 10.0327 10.1895 10.9053 10.1895 11.9821Z",
      fill: "url(#paint0_linear_3686_60163)"
    }), /*#__PURE__*/_jsx("g", {
      opacity: "0.5",
      children: /*#__PURE__*/_jsx("path", {
        d: "M14.0888 11.9821C14.0888 13.059 13.2159 13.9319 12.1392 13.9319C11.0622 13.9319 10.1895 13.059 10.1895 11.9821C10.1895 10.9053 11.0622 10.0327 12.1392 10.0327C13.2159 10.0327 14.0888 10.9053 14.0888 11.9821Z",
        fill: "url(#paint1_linear_3686_60163)"
      })
    }), /*#__PURE__*/_jsx("path", {
      d: "M22.8907 10.3188H22.8777V10.2346H22.8915C22.9295 10.2346 22.9493 10.2483 22.9493 10.2761C22.9493 10.3045 22.9292 10.3188 22.8907 10.3188ZM23.0262 10.2748C23.0262 10.2107 22.982 10.1756 22.9043 10.1756H22.8008V10.4977H22.8777V10.3727L22.9679 10.4977H23.0617L22.9558 10.3649C23.0011 10.3525 23.0262 10.3196 23.0262 10.2748",
      fill: "#231F20"
    }), /*#__PURE__*/_jsx("path", {
      d: "M22.9182 10.5666C22.7951 10.5666 22.6945 10.4641 22.6945 10.3363C22.6945 10.2081 22.7939 10.1057 22.9182 10.1057C23.0407 10.1057 23.1405 10.2103 23.1405 10.3363C23.1405 10.4631 23.0407 10.5666 22.9182 10.5666ZM22.9193 10.0551C22.7628 10.0551 22.6387 10.1799 22.6387 10.3359C22.6387 10.4918 22.7643 10.6167 22.9193 10.6167C23.0717 10.6167 23.1965 10.4904 23.1965 10.3359C23.1965 10.1822 23.0717 10.0551 22.9193 10.0551",
      fill: "#231F20"
    })]
  }), /*#__PURE__*/_jsxs("g", {
    clipPath: "url(#clip1_3686_60163)",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M24.0188 14.179C24.0188 14.179 17.1474 19.0277 4.5625 21.1978H24.0188V14.179Z",
      fill: "#F47216"
    }), /*#__PURE__*/_jsx("path", {
      d: "M1.92157 12.8903C1.697 13.0932 1.40518 13.1817 0.943304 13.1817H0.751446V10.758H0.943304C1.40518 10.758 1.68553 10.8407 1.92157 11.0545C2.16879 11.2746 2.31746 11.6158 2.31746 11.9668C2.31746 12.3187 2.16879 12.6702 1.92157 12.8903ZM1.08645 10.1372H0.0371094V13.802H1.08093C1.63598 13.802 2.03668 13.6712 2.38854 13.3789C2.80667 13.033 3.05389 12.5115 3.05389 11.9722C3.05389 10.8906 2.24582 10.1372 1.08645 10.1372",
      fill: "#231F20"
    }), /*#__PURE__*/_jsx("path", {
      d: "M3.38281 13.8021H4.09771V10.1371H3.38281V13.8021Z",
      fill: "#231F20"
    }), /*#__PURE__*/_jsx("path", {
      d: "M5.84598 11.5435C5.41696 11.3848 5.29108 11.2801 5.29108 11.082C5.29108 10.8512 5.51551 10.6758 5.82361 10.6758C6.0377 10.6758 6.21384 10.7639 6.40004 10.9726L6.77413 10.4828C6.46673 10.2139 6.09901 10.0766 5.69717 10.0766C5.04867 10.0766 4.55409 10.5269 4.55409 11.1266C4.55409 11.6316 4.78432 11.8901 5.45575 12.1317C5.73568 12.2305 5.87813 12.2962 5.94991 12.3404C6.09278 12.4337 6.16428 12.5658 6.16428 12.7197C6.16428 13.0166 5.92825 13.2367 5.60924 13.2367C5.26828 13.2367 4.99359 13.066 4.82906 12.7477L4.36719 13.1925C4.69653 13.676 5.09214 13.8903 5.63614 13.8903C6.37894 13.8903 6.90014 13.3962 6.90014 12.6869C6.90014 12.1045 6.65915 11.841 5.84598 11.5435Z",
      fill: "#231F20"
    }), /*#__PURE__*/_jsx("path", {
      d: "M7.125 11.9721C7.125 13.0494 7.97088 13.8846 9.05944 13.8846C9.36712 13.8846 9.63077 13.8242 9.95573 13.6711V12.8296C9.66999 13.1157 9.41682 13.2311 9.09272 13.2311C8.37272 13.2311 7.86171 12.709 7.86171 11.9668C7.86171 11.2632 8.38886 10.7081 9.05944 10.7081C9.4004 10.7081 9.65852 10.8298 9.95573 11.1205V10.2794C9.64196 10.1203 9.38397 10.0543 9.07629 10.0543C7.99325 10.0543 7.125 10.9065 7.125 11.9721Z",
      fill: "#231F20"
    }), /*#__PURE__*/_jsx("path", {
      d: "M15.6235 12.5988L14.6463 10.1371H13.8652L15.4205 13.8961H15.8052L17.3885 10.1371H16.6136L15.6235 12.5988Z",
      fill: "#231F20"
    }), /*#__PURE__*/_jsx("path", {
      d: "M17.7129 13.802H19.7402V13.1815H18.4272V12.1922H19.6919V11.5715H18.4272V10.758H19.7402V10.137H17.7129V13.802Z",
      fill: "#231F20"
    }), /*#__PURE__*/_jsx("path", {
      d: "M21.1358 11.8244H20.9269V10.7144H21.1471C21.5924 10.7144 21.8344 10.9009 21.8344 11.2576C21.8344 11.626 21.5924 11.8244 21.1358 11.8244ZM22.57 11.2191C22.57 10.5329 22.0974 10.137 21.273 10.137H20.2129V13.802H20.9269V12.3297H21.0203L22.0097 13.802H22.8889L21.735 12.2581C22.2735 12.1486 22.57 11.7802 22.57 11.2191",
      fill: "#231F20"
    }), /*#__PURE__*/_jsx("path", {
      d: "M10.1895 11.9821C10.1895 13.059 11.0622 13.9319 12.139 13.9319C13.2159 13.9319 14.0888 13.059 14.0888 11.9821C14.0888 10.9053 13.2159 10.0327 12.139 10.0327C11.0622 10.0327 10.1895 10.9053 10.1895 11.9821Z",
      fill: "url(#paint2_linear_3686_60163)"
    }), /*#__PURE__*/_jsx("g", {
      opacity: "0.5",
      children: /*#__PURE__*/_jsx("path", {
        d: "M14.0888 11.9821C14.0888 13.059 13.2159 13.9319 12.1392 13.9319C11.0622 13.9319 10.1895 13.059 10.1895 11.9821C10.1895 10.9053 11.0622 10.0327 12.1392 10.0327C13.2159 10.0327 14.0888 10.9053 14.0888 11.9821Z",
        fill: "url(#paint3_linear_3686_60163)"
      })
    }), /*#__PURE__*/_jsx("path", {
      d: "M22.8907 10.3188H22.8777V10.2346H22.8915C22.9295 10.2346 22.9493 10.2483 22.9493 10.2761C22.9493 10.3045 22.9292 10.3188 22.8907 10.3188ZM23.0262 10.2748C23.0262 10.2107 22.982 10.1756 22.9043 10.1756H22.8008V10.4977H22.8777V10.3727L22.9679 10.4977H23.0617L22.9558 10.3649C23.0011 10.3525 23.0262 10.3196 23.0262 10.2748",
      fill: "#231F20"
    }), /*#__PURE__*/_jsx("path", {
      d: "M22.9182 10.5666C22.7951 10.5666 22.6945 10.4641 22.6945 10.3363C22.6945 10.2081 22.7939 10.1057 22.9182 10.1057C23.0407 10.1057 23.1405 10.2103 23.1405 10.3363C23.1405 10.4631 23.0407 10.5666 22.9182 10.5666ZM22.9193 10.0551C22.7628 10.0551 22.6387 10.1799 22.6387 10.3359C22.6387 10.4918 22.7643 10.6167 22.9193 10.6167C23.0717 10.6167 23.1965 10.4904 23.1965 10.3359C23.1965 10.1822 23.0717 10.0551 22.9193 10.0551",
      fill: "#231F20"
    })]
  }), /*#__PURE__*/_jsxs("defs", {
    children: [/*#__PURE__*/_jsxs("linearGradient", {
      id: "paint0_linear_3686_60163",
      x1: "13.1371",
      y1: "13.5449",
      x2: "11.7872",
      y2: "11.4313",
      gradientUnits: "userSpaceOnUse",
      children: [/*#__PURE__*/_jsx("stop", {
        stopColor: "#F79613"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "0.276732",
        stopColor: "#F79613"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "0.619629",
        stopColor: "#F57915"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "0.923304",
        stopColor: "#F36318"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "1",
        stopColor: "#F36318"
      })]
    }), /*#__PURE__*/_jsxs("linearGradient", {
      id: "paint1_linear_3686_60163",
      x1: "12.924",
      y1: "13.5161",
      x2: "10.9511",
      y2: "9.65992",
      gradientUnits: "userSpaceOnUse",
      children: [/*#__PURE__*/_jsx("stop", {
        stopColor: "#F57915"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "0.583073",
        stopColor: "#D04726"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "0.981598",
        stopColor: "#D04726"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "1",
        stopColor: "#D04726"
      })]
    }), /*#__PURE__*/_jsxs("linearGradient", {
      id: "paint2_linear_3686_60163",
      x1: "13.1371",
      y1: "13.5449",
      x2: "11.7872",
      y2: "11.4313",
      gradientUnits: "userSpaceOnUse",
      children: [/*#__PURE__*/_jsx("stop", {
        stopColor: "#F79613"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "0.276732",
        stopColor: "#F79613"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "0.619629",
        stopColor: "#F57915"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "0.923304",
        stopColor: "#F36318"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "1",
        stopColor: "#F36318"
      })]
    }), /*#__PURE__*/_jsxs("linearGradient", {
      id: "paint3_linear_3686_60163",
      x1: "12.924",
      y1: "13.5161",
      x2: "10.9511",
      y2: "9.65992",
      gradientUnits: "userSpaceOnUse",
      children: [/*#__PURE__*/_jsx("stop", {
        stopColor: "#F57915"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "0.583073",
        stopColor: "#D04726"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "0.981598",
        stopColor: "#D04726"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "1",
        stopColor: "#D04726"
      })]
    }), /*#__PURE__*/_jsx("clipPath", {
      id: "clip0_3686_60163",
      children: /*#__PURE__*/_jsx("rect", {
        width: "24",
        height: "24",
        fill: "white"
      })
    }), /*#__PURE__*/_jsx("clipPath", {
      id: "clip1_3686_60163",
      children: /*#__PURE__*/_jsx("rect", {
        width: "24",
        height: "24",
        fill: "white"
      })
    })]
  })]
}));
DiscoverLogo.displayName = 'DiscoverLogo';
//# sourceMappingURL=DiscoverLogo.js.map